/**
 * Shared shape of a backend tool result as the chat transport hands it to a
 * tool card: the JSON string the tool returned, or the object once parsed.
 * A malformed string (a tool that crashed and returned prose) becomes an
 * error result instead of throwing inside the render.
 */

export type ToolRunStatus = { type: 'running' | 'complete' | 'incomplete' | string }

export function parseToolResult<T extends { status: string; error?: string }>(
  raw: T | string | undefined
): T | null {
  if (raw == null) return null
  if (typeof raw !== 'string') return raw
  try {
    return JSON.parse(raw) as T
  } catch {
    return { status: 'error', error: raw } as T
  }
}
